module.exports = __webpack_public_path__ + "media/favicon/favicon-32x32-af16e61b1829ebdb57f6672f47394108.png";